import React from 'react';
import { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import { Formik } from 'formik';
import { Grid, TextField } from '@mui/material';
import { environment } from 'apps/table-tuck-web/src/environments/environment';
import AddressPickerWithGoogle from './GoogleAutoComplete';

import { firestore } from '../../../../../../libs/firebase-service/src';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { userAddresses } from '../../../../../../libs/redux-slices/src';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
const AddressHandlerDialog = ({
  open,
  handleClose,
  setAdressvalue,
  address,
  onAddressAdded, // New callback for when address is successfully added
}) => {
  const [googleAddress, setGoogleAddress] = useState(address || '');
  const user = useSelector((state) => state.authReducer.userData);
  const adresses = useSelector((state) => state.authReducer.userAddresses);
  const dispatch = useDispatch();

  // Update googleAddress when address prop changes (for edit mode)
  useEffect(() => {
    if (address) {
      setGoogleAddress(address);
    } else {
      setGoogleAddress('');
    }
  }, [address]);

  // Reset form when dialog opens/closes
  useEffect(() => {
    if (open) {
      setErr(''); // Clear errors when dialog opens
      if (!address) {
        setGoogleAddress(''); // Clear address data for add mode
      }
    }
  }, [open, address]);

  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState();

  const getGoogleAddress = ({
    country,
    state,
    city,
    zipCode,
    placeId,
    displayName,
    lat,
    lng,
    streetNumber,
    route,
  }) => {
    setGoogleAddress({
      country,
      state,
      city,
      zipCode,
      placeId,
      displayName,
      lat,
      lng,
      streetNumber,
      route,
    });
  };
  const handleSubmit = async (values) => {
    setErr('');
    setLoading(true);

    if (Object.values(googleAddress)?.length > 0) {
      googleAddress['zipCode'] = googleAddress.zipCode
        ? googleAddress.zipCode
        : values.zipCode;

      if (!(googleAddress || googleAddress?.country || googleAddress?.city))
        return setErr(t('profilee.pleaseEnterValidAddrees'));
      if (!googleAddress?.country) {
        return setErr(t('profilee.pleaseEnterValidAddrees'));
      }
      if (
        googleAddress.zipCode !== '' ? googleAddress.zipCode : values.zipCode
      ) {
        if (address && address.id) {
          // Edit mode
          await firestore
            .collection('users')
            .doc(user?.uid)
            .collection('addresses')
            .doc(address.id)
            .set(
              {
                ...googleAddress,
                additionalDetails: values.additionalDetails,
                nickName: values.nickName,
                id: address.id,
                deliveryInstructions: values.deliveryInstructions,
                createdAt: address.createdAt || new Date(),
                validated_on: new Date(),
                primaryLine: googleAddress.displayName,
                is_deliverable: true,
                isDisplayed: true,
                delivery_store_id: null,
              },
              { merge: true }
            );
          // Update Redux
          const updatedAddresses = adresses.map((a) =>
            a.id === address.id
              ? {
                  ...googleAddress,
                  additionalDetails: values.additionalDetails,
                  nickName: values.nickName,
                  id: address.id,
                  deliveryInstructions: values.deliveryInstructions,
                  createdAt: address.createdAt || new Date(),
                  validated_on: new Date(),
                  primaryLine: googleAddress.displayName,
                  is_deliverable: true,
                  isDisplayed: true,
                  delivery_store_id: null,
                }
              : a
          );
          dispatch(userAddresses(updatedAddresses));

          // Call the callback with the updated address (for edit mode)
          if (onAddressAdded && typeof onAddressAdded === 'function') {
            const updatedAddress = {
              ...googleAddress,
              additionalDetails: values.additionalDetails,
              nickName: values.nickName,
              id: address.id,
              deliveryInstructions: values.deliveryInstructions,
              createdAt: address.createdAt || new Date(),
              validated_on: new Date(),
              primaryLine: googleAddress.displayName,
              is_deliverable: true,
              isDisplayed: true,
              delivery_store_id: null,
            };
            onAddressAdded(updatedAddress);
          }

          handleClose();
          setLoading(false);
        } else {
          // Add mode
          const doc = await firestore
            .collection('users')
            .doc(user?.uid)
            .collection('addresses')
            .doc();

          const updateDoc = await firestore.collection('restaurant').doc();
          await firestore
            .collection('users')
            .doc(user?.uid)
            .collection('addresses')
            .doc(doc.id)
            .set({
              ...googleAddress,
              additionalDetails: values.additionalDetails,
              nickName: values.nickName,
              id: doc.id,
              deliveryInstructions: values.deliveryInstructions,
              createdAt: new Date(),
              validated_on: new Date(),
              primaryLine: googleAddress.displayName,
              is_deliverable: true,
              isDisplayed: true,
              delivery_store_id: null,
            })
            .then(async () => {
              // Verify the address was actually saved
              try {
                const savedAddressDoc = await firestore
                  .collection('users')
                  .doc(user?.uid)
                  .collection('addresses')
                  .doc(doc.id)
                  .get();

                // Verification handled silently
                if (!savedAddressDoc.exists) {
                  // Address not found - handled silently
                }
              } catch (verifyError) {
                // Error verifying address save - handled silently
              }

              values.additionalDetails = '';
              setGoogleAddress('');
              const newObject = {
                ...googleAddress,
                additionalDetails: values.additionalDetails,
                nickName: values.nickName,
                id: doc.id,
                deliveryInstructions: values.deliveryInstructions,
                createdAt: new Date(),
                validated_on: new Date(),
                primaryLine: googleAddress.displayName,
                is_deliverable: true,
                isDisplayed: true,
                delivery_store_id: null,
              };
              let update = [];
              if (adresses == null) {
                update = [newObject];
              } else update = [...adresses, newObject];

              dispatch(userAddresses(update));

              // Call the callback with the newly added address
              // If the callback returns false, keep the dialog open (e.g. validation failed)
              let shouldClose = true;
              if (onAddressAdded && typeof onAddressAdded === 'function') {
                const result = onAddressAdded(newObject);
                if (result === false) shouldClose = false;
              }

              if (shouldClose) handleClose();
              setLoading(false);
            })
            .catch((e) => {
              // Error handled silently
              setLoading(false);
            });
          await firestore
            .collection('restaurant')
            .doc('Restaurant')
            .set(
              {
                update_items_id: updateDoc.id,
              },
              { merge: true }
            )
            .catch((e) => {});
        }
      } else setErr(t('profilee.pleaseAddZipcode'));
    } else {
      setErr(t('profilee.pleaseAddValidAddress'));
    }
  };
  const [t] = useTranslation();
  const validationSchema = yup.object().shape({
    nickName: yup
      .string()
      .required(t('profilee.addressNameRequired'))
      .test(
        'no-leading-trailing-spaces',
        t('profilee.addressNameCannotHaveLeadingTrailingSpaces'),
        (value) => {
          if (value) {
            const trimmedValue = value.trim();
            return value === trimmedValue;
          }
          return true;
        }
      )
      .test(
        'no-multiple-spaces',
        t('profilee.addressNameCannotHaveMultipleConsecutiveSpaces'),
        (value) => {
          if (value) {
            return !/\s{2,}/.test(value);
          }
          return true;
        }
      ),
    zipCode: yup
      .string()
      .trim()
      .test('zipcode-required', t('profilee.Ziprequired'), function (value) {
        return !!(value || googleAddress.zipCode);
      })
      .test(
        'zipcode-format',
        t('profilee.Zipcodemustdigits'),
        function (value) {
          const zipCodeToValidate = value || googleAddress.zipCode;
          if (zipCodeToValidate) {
            return /^\d{5}(-\d{4})?$/.test(zipCodeToValidate);
          }
          return true;
        }
      ),
  });
  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        sx={{ zIndex: (theme) => theme.zIndex.modal + 200 }}
        BackdropProps={{ sx: { zIndex: (theme) => theme.zIndex.modal + 199 } }}
        PaperProps={{
          sx: {
            borderRadius: '20px',
            overflow: 'hidden',
            maxWidth: '600px',
            width: '100%',
            zIndex: (theme) => theme.zIndex.modal + 200,
          },
        }}
      >
        <div
          style={{
            background: `linear-gradient(135deg, ${environment.mainColor} 0%, ${environment.mainColor}dd 100%)`,
            padding: '20px 24px 0px 24px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          <div style={{ flex: 1 }} />
          <CancelRoundedIcon
            style={{
              color: 'white',
              cursor: 'pointer',
              fontSize: '28px',
              transition: 'transform 0.2s ease',
            }}
            onClick={handleClose}
            onMouseEnter={(e) => (e.target.style.transform = 'scale(1.1)')}
            onMouseLeave={(e) => (e.target.style.transform = 'scale(1)')}
          />
        </div>

        <DialogTitle
          style={{
            color: 'white',
            background: `linear-gradient(135deg, ${environment.mainColor} 0%, ${environment.mainColor}dd 100%)`,
            display: 'flex',
            justifyContent: 'center',
            paddingTop: '0px',
            paddingBottom: '24px',
            paddingLeft: '24px',
            paddingRight: '24px',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontFamily: 'Jost, sans-serif',
                fontWeight: 700,
                fontSize: '24px',
                color: 'white',
                marginBottom: '8px',
              }}
            >
              {t('profilee.addressDelivery')}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontFamily: 'Jost, sans-serif',
                fontSize: '14px',
                color: 'rgba(255, 255, 255, 0.9)',
              }}
            >
              Add a new delivery address to your account
            </Typography>
          </div>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{
            padding: '32px',
            backgroundColor: '#FAFAFA',
          }}
        >
          <Typography
            component="h6"
            variant="h6"
            style={{
              fontFamily: 'Jost, sans-serif',
              fontWeight: 600,
              marginBottom: '24px',
              color: '#172B4D',
              fontSize: '18px',
            }}
          >
            {t('profilee.addressDetails')}
          </Typography>
          <Formik
            initialValues={{
              additionalDetails: address?.additionalDetails || '',
              deliveryInstructions: address?.deliveryInstructions || '',
              nickName: address?.nickName || '',
              zipCode: address?.zipCode || googleAddress.zipCode || '',
              address: {
                additionalDetails: address?.additionalDetails || '',
                deliveryInstructions: address?.deliveryInstructions || '',
              },
            }}
            enableReinitialize={true}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({
              handleBlur,
              handleChange,
              values,
              errors,
              handleSubmit,
              touched,
              setFieldValue,
            }) => {
              useEffect(() => {
                if (googleAddress.zipCode && !values.zipCode) {
                  setFieldValue('zipCode', googleAddress.zipCode);
                }
              }, [googleAddress.zipCode, setFieldValue, values.zipCode]);

              return (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                  }}
                >
                  <Grid container spacing={3} sx={{ maxWidth: '500px' }}>
                    <Grid item md={12} xs={12}>
                      <Typography
                        variant="body2"
                        sx={{
                          fontFamily: 'Jost, sans-serif',
                          fontWeight: 600,
                          color: '#172B4D',
                          marginBottom: '8px',
                          fontSize: '14px',
                        }}
                      >
                        Search Address
                      </Typography>
                      <AddressPickerWithGoogle
                        getValues={getGoogleAddress}
                        initialValue={address ? address?.displayName || '' : ''}
                      />
                    </Grid>
                    <Grid item md={12} xs={12}>
                      <Typography
                        variant="body2"
                        sx={{
                          fontFamily: 'Jost, sans-serif',
                          fontWeight: 600,
                          color: '#172B4D',
                          marginBottom: '8px',
                          fontSize: '14px',
                        }}
                      >
                        {t('profilee.zipCode')}
                      </Typography>
                      <TextField
                        fullWidth
                        placeholder={t('profilee.zipCode')}
                        name="zipCode"
                        required
                        onChange={handleChange('zipCode')}
                        onBlur={handleBlur('zipCode')}
                        value={values.zipCode || googleAddress.zipCode || ''}
                        variant="outlined"
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck={false}
                        inputMode="numeric"
                        sx={{
                          backgroundColor: 'white',
                          borderRadius: '12px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '12px',
                            fontFamily: 'Jost, sans-serif',
                            fontSize: '14px',
                            '& fieldset': {
                              borderColor: '#E6E6E6',
                            },
                            '&:hover fieldset': {
                              borderColor: environment.mainColor,
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: environment.mainColor,
                            },
                          },
                          '& .MuiInputBase-input::placeholder': {
                            fontFamily: 'Jost, sans-serif',
                            color: '#B0B0B0',
                            fontSize: '14px',
                          },
                        }}
                      />
                      {errors.zipCode && touched.zipCode ? (
                        <Typography
                          variant="caption"
                          sx={{
                            marginTop: '8px',
                            color: '#E53E3E',
                            fontSize: '12px',
                            fontFamily: 'Jost, sans-serif',
                            display: 'block',
                          }}
                        >
                          {errors.zipCode}
                        </Typography>
                      ) : null}
                    </Grid>
                    <Grid item md={12} xs={12}>
                      <Typography
                        variant="body2"
                        sx={{
                          fontFamily: 'Jost, sans-serif',
                          fontWeight: 600,
                          color: '#172B4D',
                          marginBottom: '8px',
                          fontSize: '14px',
                        }}
                      >
                        {t('profilee.additionalDetails')}
                      </Typography>
                      <TextField
                        fullWidth
                        placeholder={t('profilee.additionalDetails')}
                        name="additionalDetails"
                        onChange={handleChange('additionalDetails')}
                        onBlur={handleBlur('additionalDetails')}
                        value={values.additionalDetails}
                        variant="outlined"
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="sentences"
                        spellCheck={false}
                        inputMode="text"
                        sx={{
                          backgroundColor: 'white',
                          borderRadius: '12px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '12px',
                            fontFamily: 'Jost, sans-serif',
                            fontSize: '14px',
                            '& fieldset': {
                              borderColor: '#E6E6E6',
                            },
                            '&:hover fieldset': {
                              borderColor: environment.mainColor,
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: environment.mainColor,
                            },
                          },
                          '& .MuiInputBase-input::placeholder': {
                            fontFamily: 'Jost, sans-serif',
                            color: '#B0B0B0',
                            fontSize: '14px',
                          },
                        }}
                      />
                      {errors.additionalDetails && touched.additionalDetails ? (
                        <Typography
                          variant="caption"
                          sx={{
                            marginTop: '8px',
                            color: '#E53E3E',
                            fontSize: '12px',
                            fontFamily: 'Jost, sans-serif',
                            display: 'block',
                          }}
                        >
                          {errors.additionalDetails}
                        </Typography>
                      ) : null}
                    </Grid>
                    <div style={{ height: '16px' }} />

                    <Grid item md={12} xs={12}>
                      <Typography
                        variant="body2"
                        sx={{
                          fontFamily: 'Jost, sans-serif',
                          fontWeight: 600,
                          color: '#172B4D',
                          marginBottom: '8px',
                          fontSize: '14px',
                        }}
                      >
                        {t('profilee.addressName')}
                      </Typography>
                      <TextField
                        fullWidth
                        placeholder={`${t('profilee.enterAddressName')}`}
                        name="nickName"
                        required
                        value={values.nickName}
                        onChange={handleChange('nickName')}
                        onBlur={handleBlur('nickName')}
                        variant="outlined"
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="words"
                        spellCheck={false}
                        inputMode="text"
                        sx={{
                          backgroundColor: 'white',
                          borderRadius: '12px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '12px',
                            fontFamily: 'Jost, sans-serif',
                            fontSize: '14px',
                            '& fieldset': {
                              borderColor: '#E6E6E6',
                            },
                            '&:hover fieldset': {
                              borderColor: environment.mainColor,
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: environment.mainColor,
                            },
                          },
                          '& .MuiInputBase-input::placeholder': {
                            fontFamily: 'Jost, sans-serif',
                            color: '#B0B0B0',
                            fontSize: '14px',
                          },
                        }}
                      />
                      {errors.nickName && touched.nickName ? (
                        <Typography
                          variant="caption"
                          sx={{
                            marginTop: '8px',
                            color: '#E53E3E',
                            fontSize: '12px',
                            fontFamily: 'Jost, sans-serif',
                            display: 'block',
                          }}
                        >
                          {errors.nickName}
                        </Typography>
                      ) : null}
                      <Grid item lg={12} style={{ marginTop: '16px' }}>
                        <div
                          style={{
                            display: 'flex',
                            gap: '8px',
                            flexWrap: 'wrap',
                          }}
                        >
                          {['Home', 'Work', 'University'].map((label) => (
                            <Button
                              key={label}
                              variant={
                                values.nickName === label
                                  ? 'contained'
                                  : 'outlined'
                              }
                              onClick={() => setFieldValue('nickName', label)}
                              sx={{
                                borderRadius: '20px',
                                padding: '8px 16px',
                                fontFamily: 'Jost, sans-serif',
                                fontSize: '12px',
                                fontWeight: 600,
                                textTransform: 'capitalize',
                                border: `1px solid ${environment.mainColor}`,
                                backgroundColor:
                                  values.nickName === label
                                    ? environment.mainColor
                                    : 'transparent',
                                color:
                                  values.nickName === label
                                    ? 'white'
                                    : environment.mainColor,
                                '&:hover': {
                                  backgroundColor:
                                    values.nickName === label
                                      ? environment.mainColor
                                      : `${environment.mainColor}10`,
                                  border: `1px solid ${environment.mainColor}`,
                                },
                              }}
                            >
                              {t(`profilee.${label.toLowerCase()}`)}
                            </Button>
                          ))}
                        </div>
                      </Grid>
                    </Grid>

                    <Grid item md={12} xs={12}>
                      <Typography
                        variant="body2"
                        sx={{
                          fontFamily: 'Jost, sans-serif',
                          fontWeight: 600,
                          color: '#172B4D',
                          marginBottom: '8px',
                          fontSize: '14px',
                        }}
                      >
                        {t('profilee.deliveryInstructions')}
                      </Typography>
                      <TextField
                        placeholder={`${t('profilee.deliveryInstructions')}`}
                        fullWidth
                        variant="outlined"
                        name="deliveryInstructions"
                        onChange={handleChange('deliveryInstructions')}
                        onBlur={handleBlur('deliveryInstructions')}
                        value={values.deliveryInstructions}
                        multiline
                        rows={3}
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="sentences"
                        spellCheck={false}
                        inputMode="text"
                        sx={{
                          backgroundColor: 'white',
                          borderRadius: '12px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '12px',
                            fontFamily: 'Jost, sans-serif',
                            fontSize: '14px',
                            '& fieldset': {
                              borderColor: '#E6E6E6',
                            },
                            '&:hover fieldset': {
                              borderColor: environment.mainColor,
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: environment.mainColor,
                            },
                          },
                          '& .MuiInputBase-input::placeholder': {
                            fontFamily: 'Jost, sans-serif',
                            color: '#B0B0B0',
                            fontSize: '14px',
                          },
                        }}
                      />
                      {errors.deliveryInstructions &&
                      touched.deliveryInstructions ? (
                        <Typography
                          variant="caption"
                          sx={{
                            marginTop: '8px',
                            color: '#E53E3E',
                            fontSize: '12px',
                            fontFamily: 'Jost, sans-serif',
                            display: 'block',
                          }}
                        >
                          {errors.deliveryInstructions}
                        </Typography>
                      ) : null}
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '24px',
                      }}
                    >
                      <div
                        style={{
                          width: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          gap: '16px',
                        }}
                      >
                        {err && (
                          <Typography
                            sx={{
                              color: '#E53E3E',
                              fontWeight: 600,
                              fontSize: '14px',
                              fontFamily: 'Jost, sans-serif',
                              textAlign: 'center',
                              padding: '12px 16px',
                              backgroundColor: '#FEF2F2',
                              borderRadius: '8px',
                              border: '1px solid #FECACA',
                            }}
                          >
                            {err}
                          </Typography>
                        )}
                        <Button
                          variant="contained"
                          onClick={handleSubmit}
                          disabled={loading}
                          sx={{
                            backgroundColor: environment.mainColor,
                            color: 'white',
                            padding: '14px 32px',
                            borderRadius: '12px',
                            fontFamily: 'Jost, sans-serif',
                            fontSize: '16px',
                            fontWeight: 600,
                            textTransform: 'capitalize',
                            boxShadow: `0px 4px 12px ${environment.mainColor}40`,
                            minWidth: '200px',
                            '&:hover': {
                              backgroundColor: environment.mainColor,
                              opacity: 0.9,
                              transform: 'translateY(-1px)',
                              boxShadow: `0px 6px 16px ${environment.mainColor}50`,
                            },
                            '&:disabled': {
                              backgroundColor: '#CCCCCC',
                              color: '#666666',
                            },
                            transition: 'all 0.2s ease-in-out',
                          }}
                        >
                          {loading ? 'Saving...' : t('profilee.saveAddress')}
                        </Button>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              );
            }}
          </Formik>
        </DialogContent>
        <DialogActions
          style={{
            display: 'flex',
            justifyContent: 'center',
            padding: '16px 32px',
            backgroundColor: '#FAFAFA',
          }}
        ></DialogActions>
      </Dialog>
    </div>
  );
};

export default AddressHandlerDialog;
